export const DAO_CODE = 'DEAL' + '_DAS' + '_DAO';
